// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase:{
    apiKey: "AIzaSyDtnRdedUg5iOg_8LQ1tZtkifpCckpLmg8",
    authDomain: "the-top-24b2d.firebaseapp.com",
    databaseURL: "https://the-top-24b2d.firebaseio.com",
    projectId: "the-top-24b2d",
    storageBucket: "the-top-24b2d.appspot.com",
    messagingSenderId: "683880512128"
  }
};



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/environments/environment.ts